// @flow
import DateRange from 'common/domain/DateRange';
import api from 'common/services/api';
import Spot from 'common/modules/spots/domain/Spot';

import SpotInventory from '../domain/SpotInventory';

class SpotAPI {
  buildHeaders = (token: string) => ({ Authorization: 'Bearer ' + token });

  async addSpots(spots: Spot[], callSign: string, token: string): Promise<*> {
    const body = spots.map(spot => spot.toJSON());
    const { data } = await api.post(`/statsradio/${callSign}/campaigns/spots`, body, {
      headers: this.buildHeaders(token),
    });

    return data.map(spot => Spot.parse(spot));
  }

  async updateSpots(spots: Spot[], callSign: string, token: string): Promise<*> {
    const data = spots.map(spot => spot.toJSON());

    await api.put(`/statsradio/${callSign}/campaigns/spots`, data, {
      headers: this.buildHeaders(token),
    });
  }

  async fetchSpotsInDateRange(dateRange: DateRange, callSign: string, token: string): Promise<Spot[]> {
    const { from, to } = dateRange.toISO();

    const params = {
      startDateRange: from,
      endDateRange: to,
    };

    const { data } = await api.get(`/statsradio/${callSign}/campaigns/spots`, params, {
      headers: this.buildHeaders(token),
    });

    return data.map(unparsed => Spot.parse(unparsed));
  }

  async fetchInventoryInDateRange(dateRange: DateRange, callSign: string, token: string): Promise<SpotInventory[]> {
    const { from, to } = dateRange.toISO();

    const params = {
      start: from,
      end: to,
    };

    const { data } = await api.get(`/statsradio/${callSign}/sales-inventory`, params, {
      headers: this.buildHeaders(token),
    });

    return data.map(unparsed => SpotInventory.parse(unparsed));
  }

  async fetchSpotsForCampaignInDateRange(dateRange: DateRange, campaignReference: string, callSign: string, token: string): Promise<Spot[]> {
    const { from, to } = dateRange.toISO();

    const params = {
      startDateRange: from,
      endDateRange: to,
    };
    const { data } = await api.get(`/statsradio/${callSign}/campaigns/${campaignReference}/spots`, params, {
      headers: this.buildHeaders(token),
    });

    return data.map(unparsed => Spot.parse(unparsed));
  }

  async deleteSpots(spots: Spot[], callSign: string, token: string): Promise<*> {
    const data = spots.map(spot => spot.toJSON());

    await api.post(`/statsradio/${callSign}/campaigns/spots/deletes`, data, {
      headers: this.buildHeaders(token),
    });
  }
}

export default new SpotAPI();



// WEBPACK FOOTER //
// ./src/statsradio/modules/spots/services/SpotAPI.js